const queryString = require('query-string');
const Parse = require('url-parse');
const { FILTERS_IDS, FILTERS_ORIGINS } = require('./constants');

const getMainFilterApplied = (filterApplied) => {
  // Order matters
  if (filterApplied[FILTERS_IDS.DOMAIN]) return FILTERS_IDS.DOMAIN;
  if (filterApplied[FILTERS_IDS.PRICE]) return FILTERS_IDS.PRICE;
  if (filterApplied[FILTERS_IDS.PROMOTION_TYPE]) return FILTERS_IDS.PROMOTION_TYPE;

  return FILTERS_IDS.CONTAINER;
};

const buildSelectorsUrl = ({ actualLocation, filterApplied = {}, filterPosition = 0, recommendedDomain }) => {
  const fragment = {
    origin: FILTERS_ORIGINS.SELECTOR,
    filter_applied: getMainFilterApplied(filterApplied),
    filter_position: filterPosition + 1,
    is_recommended_domain: recommendedDomain,
  };

  return decodeURIComponent(
    queryString.stringifyUrl({
      url: queryString.parseUrl(actualLocation).url,
      query: filterApplied,
      fragmentIdentifier: queryString.stringify(fragment),
    }),
  );
};

const prepareQueryParams = (appliedFilters) => {
  if (Array.isArray(appliedFilters)) {
    return appliedFilters.reduce((newQuery, filter) => {
      newQuery[filter.id] = filter.values[0]?.id;
      return newQuery;
    }, {});
  }

  return Object.keys(appliedFilters).reduce((newQuery, key) => {
    newQuery[key] = appliedFilters[key].value || appliedFilters[key];
    return newQuery;
  }, {});
};

const buildUrl = ({
  actualLocation,
  filterId,
  filterValueId,
  addQueryParam = true,
  isPagination = false,
  filterPosition = 0,
}) => {
  const parsedUrl = new Parse(actualLocation, true);
  let { query } = parsedUrl;
  const { origin, pathname } = parsedUrl;

  if (addQueryParam) {
    query = { ...query, [filterId]: filterValueId };
  } else {
    delete query[filterId];
  }

  let fragment = { filter_applied: filterId, filter_position: filterPosition, origin: FILTERS_ORIGINS.QCAT };

  if (!isPagination) {
    delete query.page;
  } else {
    // Si es link de paginado, se elimina el fragment
    fragment = {};
  }

  return decodeURIComponent(
    queryString.stringifyUrl({
      url: `${origin}${pathname}`,
      query,
      fragmentIdentifier: queryString.stringify(fragment),
    }),
  );
};

function getMinMaxPriceAsString(minimum = 0, maximum = 0, siteId) {
  const isMLV = siteId === 'MLV';
  let min = minimum;
  let max = maximum;
  // If min is greater than max, swap them
  if (min > max && !isMLV) {
    if (max !== 0) {
      const temp = min;
      min = max;
      max = temp;
    } else {
      max = 0;
    }
  }

  if (min > max && isMLV) {
    if (max !== 0) {
      const temp = min;
      min = max;
      max = temp;
    } else {
      max = '*';
    }
  }

  let minPrice;
  if (min === '' || min === 0) {
    minPrice = isMLV ? '*USD' : '*';
  } else {
    minPrice = isMLV ? `${min}USD` : `${min}.0`;
  }

  let maxPrice;
  if (max === '' || max === 0) {
    maxPrice = isMLV ? '*USD' : '*';
  } else {
    maxPrice = isMLV ? `${max}USD` : `${max}.0`;
  }

  return {
    price: `${minPrice}-${maxPrice}`,
    addQueryParam: minPrice !== '*' || maxPrice !== '*',
  };
}

const cleanObject = (obj) => {
  const result = {};

  const isEmptyObject = (elem) => {
    return typeof elem === 'object' && Object.keys(elem).length === 0;
  };
  const isEmptyArray = (elem) => {
    return Array.isArray(elem) && elem.length === 0;
  };
  Object.keys(obj).forEach((key) => {
    if (
      obj[key] !== undefined &&
      obj[key] !== null &&
      obj[key] !== '' &&
      !isEmptyObject(obj[key]) &&
      !isEmptyArray(obj[key])
    ) {
      result[key] = obj[key];
    }
  });
  return result;
};

module.exports = {
  buildSelectorsUrl,
  cleanObject,
  getMainFilterApplied,
  buildUrl,
  getMinMaxPriceAsString,
  prepareQueryParams,
};
